import Icon from '@/components/ui/icons/Icon';
import Link from 'next/link';
import React from 'react';
import { NavItem } from './DesktopNavigation';

export const SubNavigator = ({ item, pathname, activeSubNav, setActiveSubNav }: { item: NavItem; pathname: string; activeSubNav: NavItem | null; setActiveSubNav: React.Dispatch<React.SetStateAction<NavItem | null>> }) => {
  const isRouteActive = pathname === item.href || (item.subItems && item.subItems.some((sub) => pathname.startsWith(sub.href)));
  const isHovered = activeSubNav && activeSubNav.name === item.name;
  const isItemActive = isRouteActive || isHovered;

  return (
    <div key={item.name} className='relative h-full' onMouseEnter={() => setActiveSubNav(item)}>
      <Link href={item.href} className={`relative h-full flex items-center gap-x-4 group text-base leading-6 ${isItemActive ? 'active font-bold text-base-white' : 'font-medium text-base-white'}`}>
        {item.name}
        <Icon
          name='chevron-down'
          className={`w-4 h-4 ml-1 transition-transform duration-300 ${
            // Alleen roteren als je hovert.
            isHovered ? 'rotate-180' : ''
          }`}
        />
        <div className={`absolute h-[3px] w-full bg-yellow-600 mt-[61px] transition-opacity duration-300 ease-in-out ${isItemActive ? 'opacity-100' : 'opacity-0 group-hover:opacity-100'}`} />
      </Link>
    </div>
  );
};
